var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main",
    transform: "translate(-102.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(29.931937, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(18.502618, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(53.743470, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_user_profile_man_4365213"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "user-profile-man",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.72275,9.431125 C13.93175,9.45784375 14.0920625,9.5961875 14.25475,9.7695625 C15.3704062,10.9564687 16.014625,12.551875 16.0253457,14.1959687 C16.0324375,15.3033125 14.89125,16.1102188 13.7185937,16.541875 C11.8239375,17.2389375 9.730375,17.3452188 7.69975,17.097625 C6.36321875,16.9349375 4.99878125,16.6546875 3.89203125,15.8163125 C3.38853125,15.435125 2.97053125,14.8752187 2.97465677,14.1965625 C2.985375,12.5215937 3.6491875,10.9054062 4.80046875,9.71078125 C5.0931875,9.40678125 5.64359375,9.36878125 5.84190625,9.7909375 C5.9624375,10.0474375 5.8531875,10.3265 5.63171875,10.5580625 C4.72328125,11.51875 4.18653125,12.8255937 4.1621875,14.1377812 C4.1526875,14.6305937 4.6633125,14.9565625 5.141875,15.1940625 C6.37628125,15.8068125 7.8006875,15.9867187 9.20728125,16.0152187 C10.7415312,16.0460938 12.3125937,15.8940937 13.69425,15.27125 C14.0867187,15.0943125 14.4904687,14.8882813 14.7350937,14.5266875 C14.8692812,14.3289687 14.841375,14.0475312 14.82,13.7898437 C14.7166875,12.5394062 14.15025,11.3346875 13.2536875,10.4422812 C13.2536875,10.4422812 13.1165312,10.2819687 13.088625,10.1264062 C13.0256875,9.7755 13.3397812,9.41509375 13.72275,9.431125 L13.72275,9.431125 Z M9.52671875,1.78125 C11.0455312,1.7955 12.523375,2.7075 13.2091562,4.066 C13.77975,5.1965 13.7922187,6.59240625 13.2424062,7.73359375 C12.3440625,9.597375 9.9381875,10.613875 7.9075625,9.76896875 C6.5823125,9.217375 5.5871875,7.93665625 5.3876875,6.5134375 C5.20540625,5.2119375 5.68396875,3.835625 6.63575,2.928375 C7.391,2.20815625 8.4134375,1.79134375 9.47328125,1.78125 C9.49109375,1.78125 9.50890625,1.78125 9.52671875,1.78125 L9.52671875,1.78125 Z M9.481,2.9675625 C8.12665625,2.980625 6.866125,4.00959375 6.5941875,5.33603125 C6.395875,6.30325 6.7200625,7.3636875 7.42840625,8.05540625 C8.2471875,8.8551875 9.5463125,9.12 10.6204062,8.680625 C11.8738125,8.167625 12.6700312,6.71353125 12.4129375,5.37225 C12.1605937,4.05709375 10.92975,2.9984375 9.55759375,2.96815625 C9.5320625,2.9675625 9.50653125,2.9675625 9.481,2.9675625 Z",
    id: "Shape",
    stroke: "#00458A",
    strokeWidth: 0.25,
    fill: "#00458A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUser);
export default __webpack_public_path__ + "static/media/icons_user.bc7b0499a3a16e9e3baa31faf6579e5c.svg";
export { ForwardRef as ReactComponent };